registerComponent("sections/pj-internacional", function (component) {
/**
 * Conta Internacional PJ — sem comportamento próprio.
 *
 * A entrada escalonada e a pilha `sticky` são do `sections/produtos`.
 */

});
